import { localize, configure, extend } from 'vee-validate'; 
import * as rules from 'vee-validate/dist/rules';
import Vee_Loaclize_zh_CN from 'vee-validate/dist/locale/zh_CN.json'

/**
 * 有效性验证
 * **/
var TYBM_UIValidate = (function () {

    function Init() {
        localize('zh_CN', Vee_Loaclize_zh_CN);
        configure({
            classes: {
                valid: 'has-success',
                invalid: 'has-error'
            }
        });
        Object.keys(rules).forEach(rule => {
            extend(rule, rules[rule]);
        });


        // 自定义电话号码验证规则
        extend('phone_combination', {
            validate(value, { part1, part2 }) {
                // 明确检查是否为空字符串或 null/undefined
                if (!part1 || !part2) {
                    return {
                        valid: false,
                        data: { reason: '不能为空' }
                    };
                }
                const isPart1Valid = part1 && /^\d{3,4}$/.test(part1);
                const isPart2Valid = part2 && /^\d{7,8}$/.test(part2);

                return {
                    valid: isPart1Valid && isPart2Valid
                };
            },
            params: ['part1', 'part2'],
            target: ['part1', 'part2'], // 确保监听 part1 和 part2 变化
            message: '请输入有效的区号（3-4位）和电话号码（7-8位），且区号和号码均不能为空'
        });


        extend('required_if', {
            ...rules.required_if,
            message: '{_field_} 是必需的',
            params: [...(rules.required_if.params || []), 'targetValue', 'other'], // 添加额外参数
            validate(value, { other, targetValue }) {

                window.console.log(other, targetValue);

                const dependentValue = String(other); // Ensure string comparison
                const requiredValues = Array.isArray(targetValue) ? targetValue.map(String) : [String(targetValue)];
                const forceRequired = requiredValues.includes(dependentValue);
                return !forceRequired || !!value;
            },
        });
    }


    return {
        Init: Init
    }
})();

export { TYBM_UIValidate };
